import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';
import { CategoryTreeItem } from '../sub-category-map';
import { haveChildren, trackClick, MAIN_LINK } from '../utils';
import CategoryItemChildren from './category-item-children';
import {
  CategoryImage,
  TopLevelIcon,
  TopLevelItem,
  TopLevelLink,
  TopLevelName,
} from '../styles';
import { IconChevronRight } from '@prisjakt/ui/icon/chevron-right';
import {
  trackInternalNavigationClick,
  InternalNavigationScope,
} from 'src/globals/tracking/tracking';

const CategoryListItem: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<ICategoryListItemProps>
>> = props => {
  const { index, subCategoryMap } = props;
  const topLevel = props.item;
  const { linkTo } = useContext(AppContext);

  // Use pathName if set in order to handle campaign items
  const linkToItem = (item: CategoryTreeItem) =>
    item.pathName || linkTo('category', item);
  const { logo } = topLevel;
  const logoUrl = typeof logo === 'string' ? logo : logo && logo['192'];
  return (
    <TopLevelItem
      $hasChildren={haveChildren(topLevel)}
      style={{ order: index }}
      data-test="CategoryListItem"
      data-test-level="top"
    >
      {topLevel.externalUri && (
        <TopLevelLink href={topLevel.externalUri} as="a">
          {topLevel.logo && <CategoryImage src={logoUrl} alt="Category Logo" />}
          <TopLevelName>{topLevel.name}</TopLevelName>
          <TopLevelIcon>
            <IconChevronRight size={26} />
          </TopLevelIcon>
        </TopLevelLink>
      )}
      {!topLevel.externalUri && (
        <TopLevelLink
          to={linkToItem(topLevel)}
          onClick={() => {
            trackClick(topLevel, MAIN_LINK);
            trackInternalNavigationClick({
              scope: InternalNavigationScope.CATEGORY_LIST_TOP_LVL,
              nextPage: linkToItem(topLevel),
            });
          }}
        >
          {topLevel.logo && <CategoryImage src={logoUrl} alt="Category Logo" />}
          <TopLevelName>{topLevel.name}</TopLevelName>
          <TopLevelIcon>
            <IconChevronRight size={26} />
          </TopLevelIcon>
        </TopLevelLink>
      )}
      <CategoryItemChildren
        item={topLevel}
        subCategoryMap={subCategoryMap}
        linkToItem={linkToItem}
      />
    </TopLevelItem>
  );
};

interface ICategoryListItemProps {
  item: CategoryTreeItem;
  index: number;
  subCategoryMap: Record<string, CategoryTreeItem[]>;
}

export default CategoryListItem;
